import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from '@home/home.component';

import { HAuthGuard } from '@home/service/auth.guard';
import { AuthLoginCheck } from '@home/service/auth.login.check';

import { MainComponent } from '@home/page/main/main.component';

import { MemberListComponent } from '@home/page/member-info/member-list/member-list.component';

import { RecruitComponent } from '@home/page/information/recruit/recruit.component';
import { RecruitView1Component } from '@home/page/information/recruit/recruit-view1/recruit-view1.component';
import { RecruitView2Component } from '@home/page/information/recruit/recruit-view2/recruit-view2.component';

import { InformationBiddingComponent } from '@home/page/information/information-bidding/information-bidding.component';

import { MagazineComponent } from '@home/page/customer-center/magazine/magazine.component';
import { MagazineSubscriptionComponent } from '@home/page/customer-center/magazine/magazine-subscription/magazine-subscription.component';

import { BoardComponent } from '@home/page/board/board.component';
import { BoardViewComponent } from '@home/page/board/board-view/board-view.component';

import { StatisticsComponent } from '@home/page/statistics/statistics.component';

import { LoginComponent } from '@home/page/member/login/login.component';
import { FindIdComponent } from '@home/page/member/find-id/find-id.component';
import { FindPwComponent } from '@home/page/member/find-pw/find-pw.component';
import { MemberJoinComponent } from '@home/page/member/member-join/member-join/member-join.component';
import { MemberJoinCompleteComponent } from '@home/page/member/member-join/member-join-complete/member-join-complete.component';
import { FindIdResultComponent } from '@home/page/member/find-id/find-id-result/find-id-result.component';
import { FindPwResultComponent } from '@home/page/member/find-pw/find-pw-result/find-pw-result.component';
import { MemberEdit1Component } from '@home/page/member/mypage/member-edit/member-edit1/member-edit1.component';
import { MemberWithdrawalComponent } from '@home/page/member/mypage/member-withdrawal/member-withdrawal.component';
import { MypagePaymentComponent } from '@home/page/member/mypage/mypage-payment/mypage-payment.component';
import { MemberDormantComponent } from '@home/page/member/member-dormant/member-dormant.component';

import { PaidMemberStep1Component } from '@home/page/member/mypage/paid-member/paid-member-step1/paid-member-step1.component';
import { PaidMemberStep2Component } from '@home/page/member/mypage/paid-member/paid-member-step2/paid-member-step2.component';

import { ContentsComponent } from '@home/page/contents/contents.component';
import { UnsubscribeComponent } from './page/newsletter/unsubscribe/unsubscribe.component';

import { HomeAhriComponent } from './page/home-ahri/home-ahri.component';

const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full', canActivate: [AuthLoginCheck] },
  { path: 'main', component: MainComponent, canActivate: [AuthLoginCheck] },
  { path: 'contents', component: ContentsComponent },
  { path: 'ahri', component: HomeAhriComponent },
  { path: 'member', canActivate: [AuthLoginCheck], canActivateChild: [AuthLoginCheck], runGuardsAndResolvers: 'always',
    children: [
      { path: 'list', component: MemberListComponent }
    ]
  },
  { path: 'information', canActivate: [AuthLoginCheck], canActivateChild: [AuthLoginCheck], runGuardsAndResolvers: 'always',
    children: [
      { path: 'recruit', component: RecruitComponent },
      { path: 'recruit/view1', component: RecruitView1Component },
      { path: 'recruit/view2', component: RecruitView2Component },
      { path: 'bidding', component: InformationBiddingComponent },
    ]
  },
  { path: 'customerCenter', canActivate: [AuthLoginCheck], canActivateChild: [AuthLoginCheck], runGuardsAndResolvers: 'always',
    children: [
      { path: 'magazine', component: MagazineComponent },
      { path: 'magazine/subscription', component: MagazineSubscriptionComponent },
    ]
  },
  { path: 'board', canActivate: [AuthLoginCheck], canActivateChild: [AuthLoginCheck], runGuardsAndResolvers: 'always',
    children: [
      { path: 'list', component: BoardComponent },
      { path: 'view', component: BoardViewComponent }
    ]
  },
  { path: 'statistics', component: StatisticsComponent, canActivate: [HAuthGuard] },
  { path: 'member', runGuardsAndResolvers: 'always',
    children: [
      { path: 'login', component: LoginComponent, canActivate: [AuthLoginCheck] },
      { path: 'findid', component: FindIdComponent, canActivate: [AuthLoginCheck] },
      { path: 'findpw', component: FindPwComponent, canActivate: [AuthLoginCheck] },
      { path: 'join', component: MemberJoinComponent, canActivate: [AuthLoginCheck] },
      { path: 'join/complete', component: MemberJoinCompleteComponent, canActivate: [AuthLoginCheck] },
      { path: 'findid/result', component: FindIdResultComponent, canActivate: [AuthLoginCheck] },
      { path: 'findpw/result', component: FindPwResultComponent, canActivate: [AuthLoginCheck] },
      { path: 'dormant', component: MemberDormantComponent },
      { path: 'mypage/edit', component: MemberEdit1Component, canActivate: [HAuthGuard] },
      { path: 'mypage/withdrawal', component: MemberWithdrawalComponent, canActivate: [HAuthGuard] },
      { path: 'mypage/paidmember/step1', component: PaidMemberStep1Component, canActivate: [HAuthGuard] },
      { path: 'mypage/paidmember/step2', component: PaidMemberStep2Component, canActivate: [HAuthGuard] },
      { path: 'mypage/payment', component: MypagePaymentComponent, canActivate: [HAuthGuard] }
    ]
  },
  { path: 'newsletter', runGuardsAndResolvers: 'always',
    children: [
      { path: 'unsubscribe', component: UnsubscribeComponent, canActivate: [AuthLoginCheck] },
      { path: 'refund', redirectTo: 'unsubscribe', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
